import React from 'react';
import SelectFieldMultiSelect from 'components/input/SelectFieldMultiSelect/SelectFieldMultiSelect';

const ReservationStatusFilter = <SelectFieldMultiSelect
    choices={ [
        {
            id: 'canceled',
            name: 'filters.components.reservationStatus.choices.canceled',
        },
        {
            id: 'completed',
            name: 'filters.components.reservationStatus.choices.completed',
        },
        {
            id: 'error',
            name: 'filters.components.reservationStatus.choices.error',
        },
        {
            id: 'pending',
            name: 'filters.components.reservationStatus.choices.pending',
        },
        {
            id: 'awaiting',
            name: 'filters.components.reservationStatus.choices.awaiting',
        },
        {
            id: 'split',
            name: 'filters.components.reservationStatus.choices.split',
        },
        {
            id: 'under_review',
            name: 'filters.components.reservationStatus.choices.underReview',
        },
    ] }
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='filters.components.reservationStatus.label'
    source='reservation_status'
/>;

export default ReservationStatusFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/ReservationStatusFilter.js